"use strict";

var React = _interopRequireWildcard(require("react"));
var _client = _interopRequireDefault(require("react-dom/client"));
var _reactRelay = require("react-relay");
var _environment = require("web/realea/relay/environment");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
require("web/realea/main.css");
var _reactRouterDom = require("react-router-dom");
var _themeStylex = require("web/realea/theme.stylex.js");
var _Layout = _interopRequireDefault(require("web/realea/components/Layout"));
var _HomePage = _interopRequireDefault(require("web/realea/pages/Home/HomePage"));
var _LoginPage = _interopRequireDefault(require("web/realea/pages/Login/LoginPage"));
var _AboutPage = _interopRequireDefault(require("web/realea/pages/About/AboutPage"));
var _PrivacyPage = _interopRequireDefault(require("web/realea/pages/Privacy/PrivacyPage"));
var _TermsPage = _interopRequireDefault(require("web/realea/pages/Terms/TermsPage"));
var _RouteErrorPage = _interopRequireDefault(require("web/shared/components/RouteErrorPage"));
var _ConsoleShell = _interopRequireDefault(require("web/shared/console/ConsoleShell"));
var _consoleTools = require("web/shared/console/consoleTools");
var _consoleRoutes = _interopRequireDefault(require("web/shared/consoleRoutes"));
var _reportWebVitals = _interopRequireDefault(require("web/shared/reportWebVitals"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Entry point for the Realea SPA. It mounts a react-router browser router
 * into #root, with every page wrapped in the shared <Layout/> (Header +
 * page) and <RouteErrorPage/> as the in-app error boundary.
 *
 * ⚠️ EVERY ROUTE BELOW NEEDS A MATCHING SERVER CONTROLLER — THERE IS NO
 * CATCH-ALL. Flask serves an SPA path ONLY IF a WEB `RouteController` in
 * `server/controllers/` is registered for it. WITHOUT ONE, A DIRECT VISIT,
 * BROWSER REFRESH, OR DEEP LINK TO THAT URL 404s — in-app navigation still
 * works, which is exactly why this is easy to miss. SO, WHENEVER YOU CHANGE
 * A ROUTE HERE:
 *   • ADDING a path → ADD a WEB controller for it, then run
 *     `yarn generate_controllers_init`.
 *   • REMOVING or RENAMING a path → REMOVE or RENAME its controller too, so
 *     no controller keeps serving a path that no longer exists.
 * A controller change is a SERVER change: it needs a server rebuild/restart,
 * not just a web rebuild.
 */
const rootRouter = (0, _reactRouterDom.createBrowserRouter)([{
  element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Layout.default, {}),
  errorElement: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RouteErrorPage.default, {
    homeLinkLabel: "Back to Realea"
  }),
  children: [{
    path: "/",
    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_HomePage.default, {})
  }, {
    path: "/login",
    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginPage.default, {})
  }, {
    path: "/about",
    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AboutPage.default, {})
  }, {
    path: "/privacy",
    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PrivacyPage.default, {})
  }, {
    path: "/terms",
    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TermsPage.default, {})
  },
  // No Realea viewer can hold internal access, so there is nothing to
  // gate on here: the server decides every read and write, the views say
  // so when one is refused, and the development bypass grants access
  // locally.
  {
    // controller: InternalPageController
    path: "/internal",
    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConsoleShell.default, {
      productName: "Realea",
      groups: _consoleTools.CORE_CONSOLE_GROUPS,
      landingPath: _consoleTools.JOBS_TOOL.path,
      gate: frame => frame,
      actions: []
    }),
    children: (0, _consoleRoutes.default)(page => page)
  }]
}]); // Apply Realea's design-token values to the whole document, so every component
// (Realea's own and any shared component) reads Realea's palette and type. The
// theme class carries CSS-variable overrides for the shared token contract;
// applied to <html> it themes the entire tree.
const rootElement = document.documentElement;
if (rootElement != null) {
  for (const className of (_stylex$props$classNa = (_stylex$props$classNa2 = stylex.props(_themeStylex.theme).className) === null || _stylex$props$classNa2 === void 0 ? void 0 : _stylex$props$classNa2.split(" ")) !== null && _stylex$props$classNa !== void 0 ? _stylex$props$classNa : []) {
    var _stylex$props$classNa, _stylex$props$classNa2;
    rootElement.classList.add(className);
  }
}
const root = _client.default.createRoot(document.getElementById("root"));
root.render(/*#__PURE__*/(0, _jsxRuntime.jsx)(React.StrictMode, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRelay.RelayEnvironmentProvider, {
    environment: _environment.realeaRelayEnvironment,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.RouterProvider, {
      router: rootRouter
    })
  })
}));
(0, _reportWebVitals.default)();